// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import WorldOutline from '../_raw/ui/icon_world_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(WorldOutline);
